if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
          document.dispatchEvent(
            new CustomEvent('variant:changed', {
              detail: {
                variant: this.currentVariant,
              },
            })
          );
        });

        document.querySelectorAll('.dropdown-variant').forEach(bindUrbanSalesDropdown);
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}

// Custom Dropdown Variants
function bindUrbanSalesDropdown(dropdown) {
  const toggle = dropdown.querySelector('.dropdown-variant-toggle');
  const items = dropdown.querySelectorAll('.dropdown-variant-item');

  toggle.onclick = e => {
    e.stopPropagation();
    document.querySelectorAll('.dropdown-variant.open').forEach(d => d !== dropdown && d.classList.remove('open'));
    dropdown.classList.toggle('open');
  };

  items.forEach(item => {
    item.onclick = () => {
      toggle.textContent = item.textContent;
      dropdown.classList.remove('open');
      const select = dropdown.parentNode.parentNode.querySelector('select');
      if (select) {
        select.value = item.textContent;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
  });
}

document.querySelectorAll('.dropdown-variant').forEach(bindUrbanSalesDropdown);
document.addEventListener('click', () => {
  document.querySelectorAll('.dropdown-variant.open').forEach(d => d.classList.remove('open'));
});